<template>
    <div class="warp">
        <div id="container"></div>
        <Indicator :selectFloors="currentBuild.floors"  v-if="Object.keys(currentBuild).length > 0 && !screenWhite " @closeMeter="closeMeter" @selectFloor="selectFloor" @cancelModel="cancelModel"  @backBuild="cancelBuildPopup" ref="Indicator"/>
    </div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import * as widgets from "cesium/Widgets/widgets.css";

window.viewer = null
window.Cesium = Cesium


import Earth from './js/index'
import Popup from './popup/index'
import BuildPopup from './buildPopup/index'
import BuildMessage from './buildPopup/buildOverview'
import Draw from './draw/draw.js'
import Tiles from './models/index'
import { EventBus } from './js/eventBus'
import { pageAlarm } from '../../utils/common/index'

import { buildData, flyHome, ObliquePhotographyUrl, stickToHeight} from '../../utils/viewer/lutai_wisdom_building.js'
// import { buildData, flyHome, ObliquePhotographyUrl, stickToHeight} from '../../utils/viewer/cskt_wisdom_building.js'


const Indicator = () => import("./SelectFloor/Indicator.vue")

export default {
    name: "HelloCesium",
    props:['screenWhite'],
    data(){
        return {
            popup:[], // 弹窗
            earth:null, // 地球
            buildsArr:buildData(),
            flyHome:flyHome(),
            draw:new Draw(),//工具
            tilesModel:new Tiles(),
            overview:[],  // 总览组件实体
            buildEnty:[],  // 楼宇盒子实体
            buildPopup:[],  // 楼宇指示牌
            eventHandler:null,  //点击事件,
            currentBuild:{},  // 当前选中的楼宇
            currentFloor:{text:''},  // 当前选中的楼层
            models:{},  // 楼层的模型和特征集合
            roomEntityArr:[],
            nav:'',    // 当前的导航
            selected:{  //选中模型的要素样式
                feature :undefined,
                originalColor:new Cesium.Color()
            },
            silhouette:null,  // 存储边缘检测阶段
            pick:null, // 当前选中的模型,
            monitorEnty:[],  //监控实体集合 
            planeEnty:[],  // 补洞的平面 
            BuildMessageArr:[], // 楼宇的信息牌子数组
            dianEntityArr:[], // 房间电表数组
            circleArr:{},  // 动态圆
            PDX:'', // 当前选中的配电箱
        }
    },
    components:{
        Indicator
    },
    watch:{
        'currentFloor.text'(val){
            console.log('选中楼层' + String.fromCodePoint(0x1F60A) + val );
            this.$emit('seFloor',val)
        },
        '$store.state.nav'(val){
            this.nav = val
            if(this.currentFloor.text != ''){
                this.currentNav(val)
            }
        }
    },
    mounted() {
        let _this = this
        this.init()
        this.listenr()
        
        EventBus.$on('post',(build)=>{
            _this.clickBuildPopup(build)
        })
        // EventBus.$off('post')    在楼宇牌子消失时移除监听
        
    },
    methods:{
        // 初始化
        init(){
             Cesium.Ion.defaultAccessToken =
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYjZjYWUyZi00YWRkLTRjMjUtYmNmNC0xMWViMjgxYjI4MDgiLCJpZCI6NjYxMjEsImlhdCI6MTYzMDY1MzcxN30.GTEf3cn_2IGsuOoqIuznPJ_D8py8PUt97UG7THjymnc';
        
            let _this = this
            this.earth = new Earth('container')
            this.tileset = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
                url:ObliquePhotographyUrl(),
                maximumScreenSpaceError: 1,
                maximumMemoryUsage: 2048,
            }))
            // viewer.zoomTo(this.tileset)
            // 将倾斜模型的位置贴于地面
            this.tileset.readyPromise.then(function (tileset) {
                // 正常的倾斜摄影自带地理信息
                let boundingSphere = tileset.boundingSphere;
                let cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);//获取到倾斜数据中心点的经纬度坐标（弧度）
                let surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);//倾斜数据中心点的笛卡尔坐标
                // let offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, -27);//带高程的新笛卡尔坐标
                let offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, stickToHeight());// 城市客厅
                let translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());//做差得到变换矩阵
                tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            })
            // //瓦片样式
            this.tileset.style = new Cesium.Cesium3DTileStyle({
                color: 'color("white",1)'
            })
            // viewer.zoomTo(this.tileset)
            
            viewer.camera.setView({
                destination: new Cesium.Cartesian3(this.flyHome.x ,this.flyHome.y,this.flyHome.z),
                orientation: {
                    heading:this.flyHome.heading,
                    pitch: this.flyHome.pitch,
                    roll: this.flyHome.roll,
                }
            })
            this.firstLoad()
            
            //     // 添加平面 ，效果不好
            //     // let plane = _this.draw.addPlane(build.buildFloorPlane,item.height - 0.3)
            //     // _this.planeEnty[item.text] = plane
            // })
            this.buildsArr.forEach((item , index)=>{
                item.modelFloors.forEach((val, key)=>{
                    let params = {
                        url:item.modelUrl,
                        positionModel:val.position,
                        name:val.text,
                        buildName:item.name
                    }
                    _this.addTiles(params)
                })
            })
            
        },
        firstLoad() {
            let _this = this
            let flag = true
            let helper = new Cesium.EventHelper()  // 便利对象
            let num = 0
            // 添加监听事件
            helper.add(viewer.scene.globe.tileLoadProgressEvent, function(event) {
                // console.log(event);
                
                console.log("每次加载矢量切片都会进入这个回调");
                flag && window.parent.postMessage({
                    cmd: 'loadProgress',
                    value: ++ num
                }, '*');
                if(num == 1){
                    _this.$emit('start')
                }

                if(event == 0 && flag == true){
                    flag = false
                    console.log("这个是加载最后一个矢量切片的回调")
                    window.parent.postMessage({
                        cmd: 'loadEnd',
                    }, '*');
                    
                }
            })
        },
        listenr(){
            let _this = this
            document.addEventListener('keydown', function(key){
                switch(key.key){
                    case '1':
                        console.log(viewer.camera.position)
                        console.log(viewer.camera.heading)
                        console.log(viewer.camera.pitch)
                        console.log(viewer.camera.roll)
                    break;
                    case '2':

                    break;
                    case '3':
                        _this.overview.forEach(item =>{    // 清除实体
                            viewer.entities.remove(item)
                        })
                        
                    break;
                    default:
                        break;
                }
            })

            // 添加点击事件
            this.eventHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)

            // silhouette 轮廓，创建轮廓
            this.silhouette = Cesium.PostProcessStageLibrary.createEdgeDetectionStage()
            //createEdgeDetectionStage创建边缘检测阶段
            this.silhouette.uniforms.color = Cesium.Color.BLACK
            this.silhouette.uniforms.length = 0.1
            this.silhouette.selected = []
            // postProcessStages后期效果应用于最终渲染添加     createSilhouetteStage类创建一个应用轮廓效果的后期处理阶段，轮廓效果将来自边缘检测通道的颜色与输入的颜色纹理进行合成 
            viewer.scene.postProcessStages.add(Cesium.PostProcessStageLibrary.createSilhouetteStage([this.silhouette]))

            this.eventHandler.setInputAction(function (moment) {
                
                let pick = viewer.scene.pick(moment.position)
                _this.pick = pick
                console.log(pick);
                if(!Cesium.defined(pick)){
                    console.log('没有选中模型');
                    return
                }

                if(Cesium.defined(pick) && Cesium.defined(pick.id) && Cesium.defined(pick.id._name)){
                    // 点击楼层实体
                    if(pick.id._name.includes('F')){
                        // _this.selectFloor(pick.id._name)
                        let idx = _this.currentBuild.floors.indexOf(pick.id._name)
                        
                        if(_this.screenWhite){
                            console.log('小屏幕反选楼层选择器');
                            _this.$emit('selectFloor',idx)
                        }else {
                            console.log('大屏幕反选楼层选择器');
                            _this.$refs.Indicator.current = idx
                        }
                    // 点击监控实体
                    // }else if(pick.id._name.includes('JianKon')){
                    }else if(pick.id._name.includes('JianKon_qj4')){// 暂时只能选中监控4，其他 不可选中
                        // 选中的实体来找对应的模型
                        let one = _this.models[_this.currentBuild.name + _this.currentFloor.text].tileFeature.find(item => item.getProperty('name') == pick.id._name)
                        _this.pick = one
                        let propertyNames = one.getPropertyNames()
                        let name = one.getProperty(propertyNames.find(item =>item == 'name'))

                        if (Cesium.defined(_this.selected.feature)) {
                            console.log('如果已经选中模型，恢复默认颜色');
                            // 当前如果已经选中模型，恢复默认颜色
                            _this.selected.feature.color = _this.selected.originalColor;
                            _this.circleArr[pick.id._name].ellipse.show = false
                        }
                        
                        if (_this.selected.feature == one) {
                            console.log('点击了相同的模型，去除颜色和边缘效果');

                            // 点击了相同的模型，去除颜色和边缘效果，将高亮选中效果置空
                            _this.selected.feature = undefined;
                            _this.silhouette.selected = []
                            _this.$refs.Indicator.selectDevice()
                            return;
                        }

                        _this.selected.feature = one
                        one.color = Cesium.Color.fromCssColorString('#ff5a00').withAlpha(1)

                        // 添加边缘功能
                        _this.silhouette.selected = [one]
                        _this.$refs.Indicator.selectDevice({type:"monitor",device:name})
                        // console.log(name);
                        let monitor = _this.currentBuild.monitors.find(item => item.name == name)
                        // 扩散圆
                        for(let key in _this.circleArr){
                            if(key == pick.id._name){
                                _this.circleArr[key].ellipse.show = true
                                _this.earth.fly(monitor.fly)
                            }else {
                                _this.circleArr[key].ellipse.show = false
                            }
                        }
                    // 点击电表实体
                    }else if(pick.id._name.includes('电表') ){
                        console.log('显示电表');
                        
                        _this.dianEntityArr.forEach(item =>{
                            if(item._name == pick.id._label._text._value){
                                item.show = true 
                                _this.$refs.Indicator.selectDevice({type:"meter",device:pick.id._label._text._value})
                            }else {
                                item.show = false
                            }
                        })
                    }else if(pick.id._name.includes('强电井') ){
                        console.log('强电井');
                        _this.earth.fly(_this.currentFloor.flyDian)
                    }
                }


                // 点击到模型
                if(Cesium.defined(pick._batchId)){
                    let propertyNames = pick.getPropertyNames()
                    let name = pick.getProperty(propertyNames.find(item =>item == 'name'))
                    console.log(name);
                    
                    let arr = ['ZhongYangKonTiao','SongFeng', 'JianKon', 'TonFengGuanDao', 'ZhaoMing', 'Men', 'DianBiao']
                    // 选中配电箱，隐藏配电箱外壳
                    if(name.indexOf('PDX') != -1){   //这里
                        _this.$refs.Indicator.selectDevice()
                        _this.showPdx(name)
                        
                        // viewer.zoomTo(pick.tileset, new Cesium.HeadingPitchRange(Cesium.Math.toRadians(-30), Cesium.Math.toRadians(-45), 0))
                    }else{   // 选中添加颜色 
                        arr.forEach((type,index) =>{
                            if(name.indexOf(type) != -1){
                                if (Cesium.defined(_this.selected.feature)) {
                                    // 当前如果已经选中模型，恢复默认颜色
                                    _this.selected.feature.color = _this.selected.originalColor;
                                    
                                }
                                
                                if (_this.selected.feature == pick) {
                                    // console.log('点击了相同的模型，去除颜色和边缘效果');
                                    _this.selected.feature = undefined;
                                    _this.silhouette.selected = []
                                    _this.$refs.Indicator.selectDevice()
                                    return;
                                }
                                _this.selected.feature = pick
                                
                                _this.selected.originalColor = pick.color

                                pick.color = Cesium.Color.fromCssColorString('#ff5a00').withAlpha(1)
                                // 添加边缘功能
                                _this.silhouette.selected = [pick]
                                console.log('要在这里显示弹窗');
                                _this.$refs.Indicator.selectDevice({type:"mesh",device:name})
                            }
                        })
                    }
                    
                    
    
                }
            },Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },
        
        // 添加入口
        addBillboard(){
            let entrance = this.draw.addBillboard({
                position: {lon: 116.59283837738305,lat:35.3623943378037,alt:0.5},
                image: require('@/assets/img/entrance.png'), 
                scale: 0.3,
            })
            this.overview.push(entrance)
        },
        // 添加外墙
        addParkWall(){
            let wall = this.draw.addWall({
                positions:[
                    116.59286292557316,35.36242995839889,1,
                    116.59285116091955,35.3633475637914,1,
                    116.59112652050597,35.36336388978131,1,
                    116.5910521118016,35.362347890071455,1,
                    116.59286710301934,35.36234910392014,1,
                ],
                wallHeights:[25, 25, 25, 25, 25],
                image:require('@/assets/img/wall.png')
            })
            this.overview.push(wall)
        },
        // 点击园区概况
        selectMenuPark(){
            this.addParkWall()
            this.addBillboard()

            let popup = new Popup({
                title:this.$store.state.Cang.project,
                position:{lon:116.59201747942046, lat:35.36279094856909, alt:70},
            })
            this.popup.push(popup)

            this.earth.fly(this.flyHome)
        },
        // 反选园区概况
        cancleMenuPark(){
            this.overview.forEach(item =>{    // 清除实体
                viewer.entities.remove(item)
            })
            this.popup.forEach(item =>{    // 清除弹窗 修改后不清除
                item.windowClose()
            })
        },
        // 画楼宇的盒子
        addSpace(id){
            let build = this.buildsArr.find(item =>item.id == id)
            let _this = this
            let space = _this.draw.addSpace({
                name:'build',
                positions:build.buildSpace,
                height:0,
                color:Cesium.Color.fromCssColorString('#5D91FA').withAlpha(0.4),
                lineColor:Cesium.Color.fromCssColorString('#5D91FA')
            })
            this.buildEnty.push(space)
        },
        // 添加文字点位   楼宇楼层
        addLabel(id){
            let build = this.buildsArr.find(item =>item.id == id)
            let _this = this
            build.modelFloors.forEach(item =>{
                let label = _this.draw.addLabel({
                    name: item.name, 
                    text: item.text, 
                    position:{
                        lon: item.lon, lat: item.lat, alt: item.alt
                    },
                    font:'16pt zcoolqingkehuangyouti',
                    imgShow:true
                })
                this.buildEnty.push(label)
            })

            let heightLabel = _this.draw.addLabel({name: '', text: build.heightLine.text,position:{lon: build.heightLine.lon, lat: build.heightLine.lat, alt: build.heightLine.alt}, font:'24pt zcoolqingkehuangyouti'})
                this.buildEnty.push(heightLabel)
        },
        // 画楼层标高的线
        addLine(id){
            let _this = this
            let build = this.buildsArr.find(item =>item.id == id)
            build.ElevationLines.forEach(item =>{
                let line = _this.draw.addLine({
                    name:'height',
                    positions:item
                })
                this.buildEnty.push(line)
            })
        },
        // 楼宇的牌子
        addBuildPopup(){
            this.cancleMenuBuild()
            let _this = this
            this.buildsArr.forEach(item =>{
                let buildPopup = new BuildPopup({
                    id:item.id,
                    flag:item.flag,
                    name:item.name,
                    position :{
                        lon:item.lon,
                        lat:item.lat,
                        alt:item.alt
                    }
                })
                _this.buildPopup.push(buildPopup)
            })
            this.earth.fly(this.flyHome)
        },
        // 反选楼宇分布
        cancleMenuBuild(){
            // 关闭弹窗
            this.buildPopup.forEach(item =>{
                item.windowClose()
            })
        },
        // 取消选中楼宇
        closeBuildBox(){
            this.currentBuild = {}
            this.currentFloor = {text:''}
            // 清除实体
            this.buildEnty.forEach(item =>{    
                viewer.entities.remove(item)
            })
            this.clipPlane({flag:false,planes:[]})
            for(let key in this.models){
                this.models[key].tiles.show = false
            }
            this.clearRoom()
            this.cancelMonitor()
            this.earth.fly(this.flyHome)
        },
        // 只显示相应裁切楼层，不显示其他 实体
        showCurrentFloorText(text){
            let text1 = text.replace('F','') * 1
            // 清除实体
            this.buildEnty.forEach(item =>{    
                let name = item._name.replace('F', '') * 1
                if(!(item._name.includes('F'))){
                    viewer.entities.remove(item)
                }else if(name > text1){
                    // viewer.entities.remove(item)
                    item.label.show = false
                    item.billboard.show = false
                }else{
                    item.label.show = true
                    item.billboard.show = true
                }
            })
        },
        // 选中楼宇
        clickBuildPopup(build){  
            // 牌子点击选中取消
            this.buildPopup.forEach(item =>{
                if(item.EL.id !== build.id){
                    item.off()
                }
            })

            this.$emit('clickBuild',build)
            this.addNonePopupBuild()
            this.cancleMenuPark()
        },
        // 按键选中楼宇
        btnsebuild(build){
            this.buildPopup.forEach(item =>{
                if(item.EL.id == build.id){
                    item.onOff()
                }
            })
        },
        // 添加没有牌子的楼宇(只会有一个没有，就是楼层直接切换退出的那个)
        addNonePopupBuild(){
            let _this = this
            let array1 = this.buildPopup
            let array2 = this.buildsArr
            let result = [];
            for(let i = 0; i < array2.length; i++){
                let obj = array2[i];
                let id = obj.id;
                let isExist = false;
                for(let j = 0; j < array1.length; j++){
                    let aj = array1[j];
                    let n = aj.EL.id;
                    if(n == id){
                        isExist = true;
                        break;
                    }
                }
                if(!isExist){
                    result.push(obj);
                }
            }

            result.forEach(item =>{
                let buildPopup = new BuildPopup({
                    id:item.id,
                    flag:item.flag,
                    name:item.name,
                    position :{
                        lon:item.lon,
                        lat:item.lat,
                        alt:item.alt
                    }
                })
                _this.buildPopup.push(buildPopup)
            })
            // console.log(result);
        },
        // 反选楼宇
        cancelBuildPopup(nav){
            this.cancelMonitor()
            this.clickBuildPopup({id:'',flag:false})
            this.hiddenBuildMessage()
            if(nav) return
            this.$emit('changeMenu',3,'back')
        },
        // 添加楼宇盒子和楼层显示
        showBuildBoxFloor(selectBuildId){
            this.addLabel(selectBuildId)
            this.addSpace(selectBuildId)
            this.addLine(selectBuildId)
            let build = this.buildsArr.find(item => item.id == selectBuildId)
            this.currentBuild = build
            this.earth.fly(build.fly)
        },
        // 点击改变楼层颜色和背景图片
        changeFloorTextColor(text){
            this.buildEnty.forEach(item =>{
                if(item._name == text ){
                    // item.label.fillColor = Cesium.Color.fromCssColorString('#0D94FF')
                    item.billboard.image = require('../../assets/img/floorser.png')
                }else if(item._name.includes('F')){
                    // item.label.fillColor = Cesium.Color.WHITE
                    item.billboard.image = require('../../assets/img/floornor.png')
                }
            })

            // 改变背景图片

        },
        // 裁切平面
        clipPlane(obj){
            let {
                flag = false,
                planes = []
            } = obj
            let clippingPlanes = new Cesium.ClippingPlaneCollection({
                planes:planes,
                edgeColor:Cesium.Color.WHITE,
                edgeWidth:1
            })

            let noClippingPlanes = new Cesium.ClippingPlaneCollection({
                planes: [],
                edgeColor: Cesium.Color.WHITE,
                edgeWidth:1
            })

            if(flag){
                this.tileset.clippingPlanes = clippingPlanes
            }else{
                this.tileset.clippingPlanes = noClippingPlanes
            }
        },
        // 点击楼层要做的事
        selectFloor(floor){
            this.clearRoom()
            this.currentFloor = this.currentBuild.modelFloors.find(item =>item.text == floor)
            this.changeFloorTextColor(this.currentFloor.text)
            let planes = this.currentBuild.cliplanes.concat()
            planes.push(new Cesium.ClippingPlane(new Cesium.Cartesian3(0, 0, -1), this.currentFloor.floor + 4.2))
            this.clipPlane({flag:true,planes:planes})
            // return
            this.showCurrentFloorText(this.currentFloor.text)
            for(let key in this.models){
                let reg = key.match(/\d+/g)[0]
                let reg1 = floor.match(/\d+/g)[0]

                if(key.includes(floor) && key.includes(this.currentBuild.name) && reg == reg1){
                    this.models[key].tiles.show = true
                }else {
                    this.models[key].tiles.show = false
                }
            }
            this.hiddenBuildPopup()
            
            this.hiddenBuildMessage()
            if(this.screenWhite){
                // 小屏幕交互显示区域 
                this.changeModelArrColor()
            }else {
                this.currentNav(this.$store.state.nav)
            }
            // this.addPlane()  暂时不用，效果不好
            
            this.earth.fly(this.currentFloor.fly)
        },
        // 添加3dtiles模型
        addTiles(params){
            let tiles = this.tilesModel.addThreeTiles(params)
            this.models[params.buildName + params.name] = tiles
        },
        //根据导航切换模型
        currentNav(nav){
            this.cancelMonitor()
            this.clearRoom()
            if(Object.keys(this.currentFloor).length == 0 ) return
            this.$refs.Indicator.selectDevice()

            if(nav == 'hvac'){
                this.changeModelArrColor(['ZhongYangKonTiao','TonFengGuanDao','SongFeng',])
            }else if(nav == 'lighting'){
                this.changeModelArrColor(['ZhaoMing','XianLan'])
            }else if(nav == 'security'){
                this.changeModelArrColor(['JianKon', 'Men'])
                this.showMonitor()
            }else if(nav == 'energy'){
                this.changeModelArrColor(['PDX','DianBiao'])
                this.showDianbiao()
            }else{
                this.changeModelArrColor()
            }
            
            // 清空边缘阶段
            this.silhouette.selected = []
            this.earth.fly(this.currentFloor.fly)
        },
        // 根据导航切换模型
        changeModelArrColor(types){
            let tileFeature = this.models[this.currentBuild.name + this.currentFloor.text].tileFeature

            if(types){

                if(tileFeature.length == 0){
                    setTimeout(()=>{
                        tileFeature = this.models[this.currentBuild.name + this.currentFloor.text].tileFeature
                        tileFeature.forEach(item =>{
                            this.showTypeMesh(types, item)
                        })
                    }, 1500)
                }else{
                    tileFeature.forEach(item =>{
                        this.showTypeMesh(types, item)
                    })
                }
            }else{
                tileFeature.forEach(item =>{
                    let name = item.getProperty('name')
                    // item.show = true
                    if(name.includes('DM')){
                        item.show = true
                        item.color = Cesium.Color.fromCssColorString('#CFCFCF')
                    }else if(name.includes('ZhuZi')){
                        item.show = true
                        item.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.8)
                    }else if(name.includes('QM')){ 
                        item.show = true
                        item.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.4)
                    }else if(name.includes('LouTi')){
                        item.show = true
                        item.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.4)
                    }else{
                        item.color = new Cesium.Color()
                        item.show = false
                    }
                })
                this.currentBuild.rooms.forEach(item =>{
                    let space = item.space.toString().replaceAll('-', this.currentFloor.height + 0.6 +'').split(',').map(val => val = val / 1)
                    let color = '#'+('00000'+ (Math.random()*0x1000000<<0).toString(16)).substr(-6); 
                    this.drawRoomSpace(space, color, item.lineColor, item.aph, Number( this.currentFloor.position.alt) + 104, item.name,item.name)
                })
            }
        },
        // 显示相应模块的模型
        showTypeMesh(types, item){
            let name = item.getProperty('name')
            let arr = ['ZhongYangKonTiao', 'SongFeng', 'JianKon', 'TonFengGuanDao', 'ZhaoMing','XianLan', 'Men','LouTi','NvCe','NanCe','XiShouJian','PDX', 'DianBiao']
            let modelType = this.currentBuild.modelType

            types.forEach((type,index) =>{
                if(name.indexOf(type) != -1){
                    let currentType = modelType.find(val => val.type == type)
                    item.color = currentType.color
                    item.show = currentType.show

                    let idx = arr.findIndex(item => item == type)
                    arr.splice(idx, 1)
                }else{
                    arr.forEach(val =>{
                        if(name.includes(val)){
                            item.show = false
                            item.color = new Cesium.Color()
                        }
                    })
                    
                }
            })
        },
        // 画房间空间
        drawRoomSpace(space, color, lineColor, aph, height,roomName,image,textShow,imageshow,typeName){
            let params = {
                name : "room",
                positions : space,
                height,
                color:Cesium.Color.fromCssColorString(color).withAlpha(aph),
                lineColor
            }
            let room = this.draw.addSpace(params)
            this.roomEntityArr.push(room)
            this.addTitle(space,height,roomName,image,textShow,imageshow,typeName)
        },
        // 求矩形的中心坐标，添加标题
        addTitle(space,height,roomName,image,textShow,imageshow,typeName,pixelOffset){
            let arr = pageAlarm(space,3)  // 将
            let west = 0
            let south = 0
            let east = 0
            let north = 0
            arr.forEach((item,index) =>{
                if(index == 0){
                    west += parseFloat(item[0])
                }else if(index == 1){
                    south += parseFloat(item[1])
                }else if(index == 2){
                    east += parseFloat(item[0])
                }else if(index == arr.length - 1){
                    north += parseFloat(item[1])
                }
            })

            let lonn = Number((west + east) / 2)
            let latt = Number((south + north) / 2)
            let imgShow = false
            if(imageshow){
                imgShow = true
            }else{
                imgShow = false
            }
            let label = this.draw.addLabel({name: typeName, text: roomName,position:{lon: lonn, lat: latt, alt: height + 0.5},font:'14pt Source Han Sans CN',image,imgShow,textShow,pixelOffset})
            this.roomEntityArr.push(label)
        },
        // 清除空间和标题
        clearRoom(){
            this.roomEntityArr.forEach(item =>{
                viewer.entities.remove(item)
            })
            this.dianEntityArr.forEach(item =>{
                viewer.entities.remove(item)
            })
            
        },
        // 取消模型选中
        cancelModel(){
            if (Cesium.defined(this.selected.feature)) {
                // 当前如果已经选中模型，恢复默认颜色
                this.selected.feature.color = this.selected.originalColor;
            }
            
            // 扩散圆
            for(let key in this.circleArr){
                this.circleArr[key].ellipse.show = false
            }

            if (this.selected.feature == this.pick) {
                // 点击了相同的模型，去除颜色和边缘效果，
                this.selected.feature = undefined;
                this.silhouette.selected = []
                this.$refs.Indicator.selectDevice()
                return
            }else{
                this.selected.feature = undefined;
                this.silhouette.selected = []
                this.$refs.Indicator.selectDevice()
            }
        },
        // 关闭电表窗口
        closeMeter(){
            this.$refs.Indicator.selectDevice()
            this.dianEntityArr.forEach(item =>{
                item.show = false
            })
        },
        // 展示监控点位
        showMonitor() {
            let _this = this
            
            this.currentBuild.monitors.forEach(item => {
                
                let monitor = _this.draw.addBillboard({
                    position: {lon: item.position.lon,lat:item.position.lat,alt:_this.currentFloor.height + 4},
                    image: item.image, 
                    scale: 1,
                    name:item.name
                })
                _this.monitorEnty.push(monitor)

                let circle = this.draw.addEllipse(Object.assign(item,{min:0.5, max:0.5, maxNum:2, height:_this.currentFloor.height + 4}))
                _this.circleArr[item.name] = circle
            })
        },
        // 移除监控实体
        cancelMonitor(){
            this.monitorEnty.forEach(item =>{
                viewer.entities.remove(item)
            })
            // 移除圆实体
            for(let key in this.circleArr){
                viewer.entities.remove(this.circleArr[key])
            }
            this.circleArr = {}
        },
        // 添加多边形
        addPlane(){
            this.planeEnty[this.currentFloor.text].polygon.show = true

            for(let key in this.planeEnty){
                if(key == this.currentFloor.text){
                    this.planeEnty[key].polygon.show = true
                }else{
                    this.planeEnty[key].polygon.show = false
                }
            }
        },
        // 显示当前楼宇的信息牌子
        addBuildMessage(){
            this.hiddenBuildMessage()
            let build = this.currentBuild
            let buildPopup = new BuildMessage({
                title:build.name,
                position :{
                    lon:build.lon ,
                    lat:build.lat,
                    alt:build.alt + 10
                }
            })
            this.BuildMessageArr.push(buildPopup)
            this.earth.fly(build.fly)
        },
        // 隐藏当前的楼宇信息牌
        hiddenBuildMessage(){
            this.BuildMessageArr.forEach(item =>{
                item.windowClose()
            })
        },
        //关闭选中的楼宇指示牌
        hiddenBuildPopup(){
            this.buildPopup.forEach(item =>{
                item.windowClose()
            })
            this.buildPopup = []
            let _this = this
            this.buildsArr.forEach(item =>{
                if(item.id != this.currentBuild.id){
                    let buildPopup = new BuildPopup({
                        id:item.id,
                        flag:item.flag,
                        name:item.name,
                        position :{
                            lon:item.lon,
                            lat:item.lat,
                            alt:item.alt
                        }
                    })
                    _this.buildPopup.push(buildPopup)
                }
            })
        },
        // 模型选中配电箱操作
        showPdx(pdx){
            let _this = this
            let reg = /PDX[1234]_1/
            if(reg.test(pdx)){
                test(pdx)
            }else{
                testrever(pdx)
            }

            function test(pdx){
                let arr = ['PDX1_1', 'PDX2_1', 'PDX3_1', 'PDX4_1']
                
                _this.models[_this.currentBuild.name + _this.currentFloor.text].tileFeature.forEach(item =>{
                    let name = item.getProperty('name')
                    arr.forEach(mesh =>{
                        if(name == mesh && name == pdx){
                            item.show = false
                            _this.$refs.Indicator.selectDevice({type:"pdx",device:pdx})
                        }else if(name == mesh && name != pdx){
                            item.show = true
                        }
                    })
                })
            }

            function testrever(pdx){
                let arr = ['PDX1_1', 'PDX2_1', 'PDX3_1', 'PDX4_1']
                
                _this.models[_this.currentBuild.name + _this.currentFloor.text].tileFeature.forEach(item =>{
                    let name = item.getProperty('name')
                    arr.forEach(mesh =>{
                        if(mesh.includes(pdx) && name.includes(pdx)){
                            item.show = true
                        }
                    })
                })
            }
        },
        // 添加电表电井效果
        showDianbiao(){
            this.currentBuild.rooms.forEach(item =>{
                let space = item.space.toString().replaceAll('-', this.currentFloor.height + 0.6 +'').split(',').map(val => val = val / 1)
                if(item.name.includes('强电井') || item.name.includes('弱电井')){
                    let params = {
                        name : "room",
                        positions : space,
                        height:Number( this.currentFloor.position.alt) + 104,
                        color:Cesium.Color.fromCssColorString('#269AFF').withAlpha(item.aph),
                        lineColor:item.lineColor
                    }
                    let room = this.draw.addSpace(params)
                    this.roomEntityArr.push(room)
                    this.addTitle(space,Number( this.currentFloor.position.alt) + 107,item.name,item.dianImg,true, true,item.name,[0,20])

                }else{
                    let params = {
                        name : item.name,
                        positions : space,
                        height:Number( this.currentFloor.position.alt) + 104,
                        color:Cesium.Color.fromCssColorString('#269AFF').withAlpha(0.1),
                        lineColor:item.lineColor,
                        // show:false
                    }
                    let room = this.draw.addSpace(params)
                    room.show = false
                    this.dianEntityArr.push(room)
                    this.addTitle(space,Number( this.currentFloor.position.alt) + 104,item.name,item.dianImg,true, true,'电表',[0,-30])
                }
            })
        }
    }
}
</script>
<style scoped>
#container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
}
</style>